export default __webpack_public_path__ + "static/ALEXK_BW-7e263e54d6259068083ba255417a30d3.jpg";